import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { styled, Grid } from '@mui/material';
import React from 'react';
import '../../analytics/AnalyticsService.js';
import 'branch-sdk';
import { AnalyticsTrackingEvent } from '../../analytics/events.js';
import '../../analytics/metaPixel.js';
import '../../analytics/fingerprint.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { TABLET_SCREEN_SIZE, WIDGET_SPACE, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import { sendTextCallback } from '../../utils/textMessage.js';
import BrandclubPhoneInput from '../components/BrandclubPhoneInput/index.js';
import { GenericContainer } from '../components/GenericContainer.js';

var _a, _b, _c, _d, _e, _f;
var BrandclubGetAppContainer = styled(GenericContainer)((_a = {
        background: brandclub_colors.greyBlackGround,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: WIDGET_SPACE,
        paddingBottom: WIDGET_SPACE,
        paddingLeft: '5%',
        paddingRight: '5%',
        boxSizing: 'border-box'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        background: brandclub_colors.greyBlackGround,
        padding: "".concat(WIDGET_SPACE, "px ").concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        background: brandclub_colors.greyBlackGround,
        padding: "".concat(WIDGET_SPACE, "px ").concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var OverviewContent = styled(Grid)((_b = {
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        color: brandclub_colors.mainSeriesColor,
        width: '100%',
        position: 'relative',
        justifyContent: 'center',
        flexDirection: 'row'
    },
    // gap: '0px',
    _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        flexDirection: 'column',
        gap: '40px',
    },
    _b));
var InfoContainer = styled(Grid)((_c = {
        width: '100%',
        maxWidth: 700,
        minWidth: 400,
        flexDirection: 'column',
        alignItems: 'center'
    },
    _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        width: '100%',
        minWidth: 'auto',
    },
    _c['.title'] = (_d = {
            fontSize: 50,
            fontWeight: 700,
            lineHeight: 1.2
        },
        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 26,
            textAlign: 'center',
            padding: '0 20px',
        },
        _d),
    _c['.subtitle'] = (_e = {
            marginTop: 20,
            lineHeight: 1.6,
            fontSize: 24,
            fontWeight: 500,
            marginBottom: 20
        },
        _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            fontSize: 16,
            textAlign: 'center',
            padding: '0 20px',
        },
        _e),
    _c['.cellphone_input'] = (_f = {
            minWidth: 400,
            margin: '0 auto'
        },
        _f["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            minWidth: 'fit-content',
        },
        _f),
    _c));
var BrandclubCenterDownload = function (_a) {
    var _b;
    var trackingParams = _a.trackingParams, analyticsTrack = _a.analyticsTrack, mainEntity = _a.mainEntity, axios = _a.axios, userProfile = _a.userProfile;
    return (React.createElement(BrandclubGetAppContainer, null,
        React.createElement(OverviewContent, { container: true, wrap: "nowrap", alignItems: 'center' },
            React.createElement(InfoContainer, { flex: 1, container: true },
                React.createElement("div", { className: "title" }, "Enjoy exclusive perks"),
                React.createElement("div", { className: "subtitle" },
                    "Get members-only access to cash rewards, offers, and events. The best of ", (_b = mainEntity === null || mainEntity === void 0 ? void 0 : mainEntity.entity) === null || _b === void 0 ? void 0 :
                    _b.name,
                    " \u2014 tailored just for you."),
                React.createElement("div", { className: "cellphone_input" },
                    React.createElement(BrandclubPhoneInput, { hasHeader: false, userProfile: userProfile, handleSendText: function (phoneNumber) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, sendTextCallback(phoneNumber, axios, mainEntity, analyticsTrack, trackingParams, AnalyticsTrackingEvent.WEB_APP_SOCIAL_LINK_TEXT_APP_DOWNLOAD_LINK)];
                            });
                        }); } }))))));
};

export { BrandclubCenterDownload };
//# sourceMappingURL=index.js.map
